import {Injectable} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {AppState, authLogout} from "src/app/core/core.module";
import {ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResultType} from "src/app/shared";
import {DIALOG_MAX_HEIGHT, DIALOG_WIDTH} from "../common-features";

@Injectable({
  providedIn: 'root'
})
export class FeaturesService {

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
  ) {
  }

  logout() {
    const inData: ConfirmDialogData = {
      title: 'Cerrar sesión',
      question: '¿Está seguro que desea cerrar sesión?',
      result: ConfirmDialogResultType.Cancel
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: DIALOG_WIDTH,
      maxHeight: DIALOG_MAX_HEIGHT,
      data: inData
    });
    dialogRef.afterClosed().subscribe(outData => {
      if (outData && outData.result === ConfirmDialogResultType.Ok) {
        this.store.dispatch(authLogout());
      }
    });
  }
}
